import React from 'react'

import { useInView } from 'react-cool-inview'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, bool } from 'prop-types'

import i18n from 'Pods/Shared/I18nHome'

import BusinessAccountFeatureCard from './Components/BusinessAccountFeatureCard'
import BusinessAccountIcon from './Icons/BusinessAccount'
import ClearLicensingTerms from './Icons/ClearLicensingTerms'
import EasyAssetSharing from './Icons/EasyAssetSharing'
import StreamlinedPayment from './Icons/StreamlinedPayments'

function BusinessAccount({ locale = 'en', extractingCoreStyles = false }) {
  const { observe, inView } = useInView({
    rootMargin: '200px',
    unobserveOnEnter: true,
  })

  const translate = (key, options = {}) => {
    const result = i18n.t(key, {
      ns: 'new-home',
      lng: locale,
      ...options,
    })
    return result
  }

  const translateFeature = (feature, part) => {
    return translate(`businessAccount.features.${feature}.${part}`)
  }

  const renderBusinessAccountContent = () => (
    <div className="business-account__container">
      <div className="business-account__info-container">
        <div className="business-account__badge">
          <BusinessAccountIcon width="24" height="24" />
          <span className="business-account__badge-text">
            {translate('businessAccount.badgeTitle')}
          </span>
        </div>
        <h2 className="business-account__title">
          {translate('businessAccount.title')}
        </h2>

        <p className="business-account__description">
          {translate('businessAccount.description')}
        </p>

        <Button type="primary" href="/discover/business-account" customClass="business-account__apply-button">
          {translate('businessAccount.applyButton')}
        </Button>
      </div>

      <div className="business-account__features-container">
        <BusinessAccountFeatureCard
          icon={<EasyAssetSharing width="80" height="80" />}
          title={translateFeature('easyAssetSharing', 'title')}
          description={translateFeature('easyAssetSharing', 'description')}
        />
        <BusinessAccountFeatureCard
          icon={<StreamlinedPayment width="80" height="80" />}
          title={translateFeature('streamlinedPayments', 'title')}
          description={translateFeature('streamlinedPayments', 'description')}
        />
        <BusinessAccountFeatureCard
          icon={<ClearLicensingTerms width="80" height="80" />}
          title={translateFeature('clearLicensingTerms', 'title')}
          description={translateFeature('clearLicensingTerms', 'description')}
        />
      </div>
    </div>
  )

  return (
    <div className="business-account new-home-section" ref={observe}>
      {(inView || extractingCoreStyles) && renderBusinessAccountContent()}
      <noscript>
        {renderBusinessAccountContent()}
      </noscript>
    </div>
  )
}

BusinessAccount.propTypes = {
  locale: string,
  extractingCoreStyles: bool,
}

export default BusinessAccount
